import React, { ReactElement, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { socialLinksContacUs } from '../../../lib/constants';

const Follow = (): ReactElement => {
    return (
        <div className="text-center p-4 mt-8 contact-follow-container">
            <div className="font-medium">Follow us</div>
            <div className="flex justify-center mt-5">
                {socialLinksContacUs.map((socialLink, index) => {
                    return <div key={index} className="mx-2">
                        <Link to={{ pathname: `${socialLink.link}` }} target="_blank">
                            <img src={socialLink.icon} alt={socialLink.type} />
                        </Link>
                    </div>
                })}
            </div>
        </div>
    );
};

export default Follow;
